export function round(val: number, pow: number) {
  const exp = 10 ** pow
  const res = Math.round(val * exp) / exp
  return res
}

export function equalWeights(numItems: number, dps: number) {
  const weight = round(1 / numItems, dps)
  const total = weight * numItems
  const diff = 1 - total
  const res = Array(numItems).fill(weight)
  res[numItems - 1] = weight + diff
  return res
}

export function scaleWeights(oldWeights: number[], dps: number) {
  const numAssets = oldWeights.length
  const totalWeight = oldWeights.reduce((sum, current) => sum + (current === null ? 0 : current), 0)
  const newWeights = oldWeights.map(x =>
    round(totalWeight === 0 ? round(1 / numAssets, dps) : x / totalWeight, dps)
  )
  const newTotalWeight = newWeights.reduce((sum, current) => sum + current, 0)
  const diff = 1 - newTotalWeight
  newWeights[newWeights.length - 1] = newWeights[newWeights.length - 1] + diff
  return newWeights
}

export function convertToPercentDisplay(val: number) {
  const result = `${(round(val, 4) * 100).toFixed(2)}%`
  return result
}

export function truncate(val: number, pow: number) {
  const exp = 10 ** pow
  const res = Math.trunc(val * exp) / exp
  return res
}
